import moment from 'moment-timezone';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import Slider from '@mui/material/Slider';
import { ThemeProvider } from '@mui/material';

import { changeFilter } from '../../actions';
import Strings from '../../Strings';
import { ManualDatePicker } from '../ManualDatePicker';
import DatePicker from '../Inputs/DatePicker';
import { DATE_MONTH_DAY_YEAR } from '../../constants';
import newTheme from '../../style/muiTheme';
import { getColorsForColorTheme } from '../../utils/colorTheme';

function SliderPicker(props) {
  const { dateFilter, onChange = () => { }, onChangeDateFilter, onChangeEnd = () => { } } = props;
  const { min, max, minRangeDays = 1, manualDatePicker = false } = props;

  const defaultSupremum = moment().endOf('day');
  const defaultInfimum = moment().subtract(6, 'day').startOf('day');
  const [value, setValue] = React.useState([dateFilter.infimum?.unix() || defaultInfimum.unix(), dateFilter.supremum?.unix() || defaultSupremum.unix()]);

  React.useEffect(() => {
    if (!dateFilter.infimum || !dateFilter.supremum) {
      onChangeDateFilter({
        supremum: moment().endOf('day'),
        infimum: moment().subtract(6, 'day').startOf('day'),
      });
    }
  }, [dateFilter.infimum, dateFilter.supremum]);

  const handleSliderChange = d => {
    const infimum = d.infimum.startOf('day');
    const supremum = d.supremum.endOf('day');
    onChangeDateFilter({ infimum, supremum });
    if (onChange) {
      onChange(d);
    }
  };

  const handleInfimumChange = m => {
    const infimum = m.startOf('day');
    const supremum = moment(dateFilter.supremum);
    const differanceInDays = supremum.diff(infimum, 'days');

    if (differanceInDays <= 0) {
      supremum = m.endOf('day');
      onChangeDateFilter({
        infimum,
        supremum,
      });
    } else {
      onChangeDateFilter({ infimum });
    }
    onChange({ infimum, supremum });
  };

  const handleSupremumChange = m => {
    const supremum = m.endOf('day');
    onChangeDateFilter({ supremum });
    onChange({
      infimum: dateFilter.infimum,
      supremum,
    });
  };

  const propsDatePickerInfimum = {
    minDate: min,
    maxDate: max,
    value: moment(dateFilter.infimum),
    onAccept: handleInfimumChange,
  };

  const propDatePickerSupermum = {
    minDate: moment(dateFilter.infimum),
    maxDate: max,
    value: moment(dateFilter.supremum),
    onAccept: handleSupremumChange,
  };

  const theme = React.useMemo(() => newTheme(getColorsForColorTheme().mainColor), []);

  return (
    <div className="slider-picker-wrapper">
      <div className="slider-wrapper">
        <ThemeProvider theme={theme}>
          <Slider
            value={value}
            onChange={(e, v) => setValue(v)}
            onChangeCommitted={(e, v) => handleSliderChange({ infimum: moment.unix(v[0]), supremum: moment.unix(v[1]) })}
            disabled={props.readOnly}
            valueLabelDisplay="auto"
            min={min.unix()}
            max={max.unix()}
            step={60 * 60 * 24 * minRangeDays}
            valueLabelFormat={v => { return moment(v * 1000).format(DATE_MONTH_DAY_YEAR); }}
          />
        </ThemeProvider>
      </div>
      <div className={`datepickers-wrapper ${manualDatePicker ? 'manualDatePicker' : ''}`}>
        <div className="datepicker-wrapper start-date-picker">
          <span className="outside-label">{Strings.startDate}</span>
          {manualDatePicker ? (
            <ManualDatePicker {...propsDatePickerInfimum} />
          ) : (
            <DatePicker
              id="datepicker"
              hideClearButton
              disabled={props.readOnly}
              {...propsDatePickerInfimum}
            />
          )}
        </div>
        <div className="datepicker-wrapper end-date-picker">
          <span className="outside-label">{Strings.endDate}</span>
          {manualDatePicker ? (
            <ManualDatePicker {...propDatePickerSupermum} />
          ) : (
            <DatePicker
              id="end-datepicker"
              hideClearButton
              disabled={props.readOnly}
              {...propDatePickerSupermum}
            />
          )}
        </div>
      </div>
    </div>
  );
}

SliderPicker.propTypes = {
  max: PropTypes.instanceOf(Date).isRequired,
  min: PropTypes.instanceOf(Date).isRequired,
  onChange: PropTypes.func,
  onChangeEnd: PropTypes.func,
  minRangeDays: PropTypes.number,
  dateFilter: PropTypes.object,
  onChangeDateFilter: PropTypes.func,
  manualDatePicker: PropTypes.bool,
  readOnly: PropTypes.bool,
};



const mapStateToProps = state => ({
  dateFilter: state.filter.dateFilter,
});

const mapDispatchToProps = dispatch => ({
  onChangeDateFilter: filterData => dispatch(changeFilter('dateFilter', filterData)),
});

export default connect(mapStateToProps, mapDispatchToProps)(SliderPicker);
